module.exports = __webpack_public_path__ + "static/img/elven_skirmisher2.f27a5ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/elven_skirmisher2.png
// module id = xkAM
// module chunks = 0